export default "__VITE_ASSET__0k2HwIB___"